import script from "./SyncFilePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncFilePage.vue?vue&type=script&setup=true&lang=ts"

import "./SyncFilePage.vue?vue&type=style&index=0&id=f6a67e64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6a67e64"]])

export default __exports__